export default "__VITE_ASSET__Wk45XkKM__"